import { createClient } from 'contentful'
import config from '../cf/r3c/config'

const useContentful = () => {
    let env = process.env.REACT_APP_RC_ENV || process.env.RC_ENV || 'dev'

    console.log(config, 'config')
    
    // Get config values with fallbacks
    const accessToken = config?.contentful?.deliveryToken
    const spaceID = config?.contentful?.spaceId

    if (!accessToken || !spaceID) {
        console.error('Missing required Contentful configuration')
        return {
            getCaseStudyEntry: async () => null,
            getAllCaseStudiesForBu: async () => null
        }
    }

    const dlvrClient = () => {
        return createClient({
            accessToken,
            environment: env,
            space: spaceID
        })
    }

    const getCaseStudyEntry = async (slug) => {
        try {
            const caseStudy = await dlvrClient().getEntries({
                "fields.slug": slug,
                content_type: "caseStudy"
            })
            return caseStudy
        } catch(err) {
            console.error('Error fetching case study:', err)
            return null
        }
    }

    const getAllCaseStudiesForBu = async (bu) => {
        try {
            const caseStudy = await dlvrClient().getEntries({
                "fields.type": bu,
                content_type: "caseStudy"
            })
            return caseStudy
        } catch(err) {
            console.error('Error fetching case studies:', err)
            return null
        }
    }

    return { getCaseStudyEntry, getAllCaseStudiesForBu }
}

export default useContentful
